import { i18n } from "@src/app/i18n";

export const userLocationDictionary: Record<string, string> = {
  store: i18n.global.t("На складе"),
  shopfloor: i18n.global.t("В зале"),
};
